var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "url(#paint0_radial_315_50)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66477 3.01989C2.55019 3.01989 2.44839 3.00024 2.35938 2.96094C2.27083 2.92116 2.20123 2.86648 2.15057 2.79688C2.09991 2.72727 2.07434 2.64725 2.07386 2.55682H2.47159C2.47206 2.58475 2.48059 2.60985 2.49716 2.6321C2.5142 2.65388 2.53741 2.67093 2.56676 2.68324C2.59612 2.69555 2.62973 2.7017 2.66761 2.7017C2.70407 2.7017 2.73627 2.69531 2.7642 2.68253C2.79214 2.66927 2.81392 2.65104 2.82955 2.62784C2.84517 2.60464 2.85275 2.57812 2.85227 2.5483C2.85275 2.51894 2.84375 2.4929 2.82528 2.47017C2.80729 2.44744 2.78196 2.42969 2.74929 2.4169C2.71662 2.40412 2.67898 2.39773 2.63636 2.39773H2.48864V2.125H2.63636C2.67566 2.125 2.71023 2.11861 2.74006 2.10582C2.77036 2.09304 2.7938 2.07528 2.81037 2.05256C2.82741 2.02983 2.8357 2.00379 2.83523 1.97443C2.8357 1.94602 2.82884 1.92093 2.81463 1.89915C2.80043 1.87737 2.78054 1.86032 2.75497 1.84801C2.72988 1.8357 2.70076 1.82955 2.66761 1.82955C2.63163 1.82955 2.59943 1.83594 2.57102 1.84872C2.54309 1.86151 2.52107 1.87926 2.50497 1.90199C2.48887 1.92472 2.48059 1.95076 2.48011 1.98011H2.10227C2.10275 1.8911 2.12713 1.8125 2.17543 1.74432C2.2242 1.67614 2.29096 1.62263 2.37571 1.58381C2.46046 1.54498 2.55777 1.52557 2.66761 1.52557C2.77509 1.52557 2.87003 1.5438 2.95241 1.58026C3.03527 1.61671 3.09991 1.6669 3.14631 1.73082C3.19318 1.79427 3.21638 1.86695 3.21591 1.94886C3.21686 2.0303 3.18892 2.09706 3.1321 2.14915C3.07576 2.20123 3.00426 2.23201 2.91761 2.24148V2.25284C3.03504 2.26562 3.12334 2.30161 3.18253 2.3608C3.24171 2.41951 3.27083 2.49337 3.26989 2.58239C3.27036 2.66761 3.24479 2.74313 3.19318 2.80895C3.14205 2.87476 3.07079 2.92637 2.9794 2.96378C2.88849 3.00118 2.78362 3.01989 2.66477 3.01989Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_315_50",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.5 2.5) rotate(90) scale(2.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall3);
export default __webpack_public_path__ + "static/media/ball3.0fe3ab4ff9c9d616187e0328459b4dc7.svg";
export { ForwardRef as ReactComponent };